import { message } from 'antd'
import { emailSubOrder } from '../../../HttpRequests/subOrders';
import { setFileList } from '../State/fileList';
import handleException from '../../../Core/Helpers/handleException';
import fetch from '../../../Screens/SubOrder/Services/fetch';

export default (values) => async (dispatch, getState) => {

  try {

    const { id } = values;

    const data = new FormData();

    data.append('to', values.to.join(','));
    data.append('cc', values.cc.join(','));
    data.append('bcc', values.bcc.join(','));
    data.append('subject', values.subject);
    data.append('body', values.body);

    const { fileList } = getState().modals.EmailSubOrder;

    fileList.forEach((file) => {
      data.append('files[]', file);
    });

    const response = await emailSubOrder({ id, data });

    message.success("Mail Queued");

    dispatch(setFileList([]));

    // Refresh SubOrder data to show updated status
    await dispatch(fetch());

    return true;

  } catch(error) {

    handleException(error);

    return false;
  }
}
